import React, { useEffect } from 'react';
import { ReactNode } from 'react';

import { useTheme } from '../router/themeContext';
import css from './layout.module.css';

const THEME_POSTFIX = '-theme';

const Layout = ({
  sidebar,
  topbar,
  children,
  className = '',
}: {
  sidebar: ReactNode;
  topbar: ReactNode;
  children?: ReactNode;
  className?: string;
}) => {
  const themeContext = useTheme();

  useEffect(() => {
    const bodyRef = document.querySelector('body');
    bodyRef.classList.forEach((className) => {
      className.endsWith(THEME_POSTFIX) && bodyRef.classList.remove(className);
    });

    bodyRef.classList.add(themeContext);
  }, [themeContext]);

  return (
    <div className={`${css['layout']} ${className}`}>
      <div className={css['left']}>{sidebar}</div>
      <div className={css['right']}>
        <div className={`${css['top']} default-theme`}>{topbar}</div>
        <div className={`${css['center']} ${themeContext}`}>{children}</div>
      </div>
    </div>
  );
};

export default Layout;
